













import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import { i18n } from './../../../../i18n';
import VueI18n from 'vue-i18n';

const name = 'ttam-languages';
export default defineComponent({
  name,
  props: {
    label: {
      type: String,
    },
    value: {
      type: Array as PropType<string[]>,
      required: true,
      default: () => [],
    },
    options: {
      type: Array as PropType<
        {
          id: string;
          code: string;
          label?: VueI18n.TranslateResult;
          hidden?: boolean;
          i18n?: VueI18n.TranslateResult;
        }[]
      >,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const { label } = toRefs(props);
    const _languageList = computed({
      get: () => props.value,
      set: val => {
        emit('input', val);
        emit('change', val);
      },
    });
    function selectedLabel(arr) {
      const count = arr?.length;
      if (!count) {
        return i18n.t('list_no_limit');
      }
      if (count === 1 && (arr[0] === 'ALL' || arr[0] === 'NO_LIMIT')) {
        return i18n.t('language_all');
      }
      emit('update-count', count);
      return label.value;
    }

    function onClearLanguages() {
      _languageList.value = [];
    }

    function onChange() {
      alert('hi');
    }
    return {
      name,
      _languageList,
      selectedLabel,
      onClearLanguages,
      onChange,
    };
  },
});
